export default __webpack_public_path__ + "static/media/kxip.8ea29521.png";